export default __webpack_public_path__ + "static/media/640_private03-nl-mobile.93194a41.png";